import { createReducer, on } from '@ngrx/store';

import { ShoppingCartDto } from '../core/dtos/dto';
import { clearShoppingCart, loadShoppingCart } from './shopping-cart.actions';

export const initialState: ShoppingCartDto = null;

export const shoppingCartReducer = createReducer(
  initialState,
  on(loadShoppingCart, (state, { shoppingCart }) => shoppingCart),

  on(clearShoppingCart, () => initialState)
);
